import React, { Component, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import Loader from '@components/common/Loader/newLoaderModal';
import { getStoreThemeUrl } from '@reducers/theme';
import { bindActionCreators } from 'redux';
import {
  authenticate,
  subscribeToStoreChecks,
  subscribeToStoreNotifications,
  getStoreNotifications,
  getStoreChecks,
  connect as socketConnector,
} from '../../../sockets/communicator';
import { getObjectValue } from '@utility/helperFunction';
import EventEmitter from '@utility/eventSubscribers';
import {
  setCardReaderStatus,
  setInActivityStatus,
  setSocketConnection,
  logout,
  setOpen,
  setScreenSaverStatus,
} from '@reducers/oauth';
// import InActivity from '@containers/common/InActivity';
// import InActivity from '@containers/common/InActivity/indexCopy';
const InActivity = lazy(() =>
  import('@containers/common/InActivity/indexCopy')
);
import { flowType } from '@utility/userInfo';
import {
  updateChecksAfterResponse,
  getAllChecks,
  getAllCheckPreps,
} from '@reducers/storeChecks';
import { setIsAssisstance } from '@reducers/checks';
import {
  checkVoid,
  clearCart,
  removeSeat,
  removePaymentCheck,
  addChecks,
  setSeat,
} from '@reducers/orders';
import { clearAuthResponse } from '@reducers/payment';
import { logCapiClientHealthInfo } from '@reducers/utils';
import { setNotification } from '@reducers/notification';
import { subscribe } from '../../../CApiWebSocket/Subscriber';
import { safeJsonParse } from '../../../utility/helperFunction';
import { setErrorOrderFlag } from '../../../reducers/fireboard/errorOrder';
import { isObjectBlank } from '../../../utility/fireboardUtil';
import { getVenueStores, getVenueNotification } from '@reducers/fireboard/venue';

class ScrollToTop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // showHeader: true,
      shouldFlip: false,
    };
  }

  componentDidMount() {
    if (window.ReactNativeWebView) {
      // EventEmitter.cardreaderInitialized((status) => {
      //   this.props.setCardReaderStatus(status);
      // });
      EventEmitter.deviceStatus(deviceState => {
        console.log('*****************componentDidMount', { deviceState });
        if (
          deviceState === 'DEVICE_UNPLUGGED' ||
          deviceState === 'DEVICE_CONNECTING' ||
          deviceState === 'DEVICE_AVAILABLE'
        ) {
          console.log('*****************componentDidMount if block', {
            deviceState,
          });
        } else {
          // props.setNotification({
          //   type: 'danger',
          //   message: 'Card Reader Error'
          // });
        }
        // this.props.setCardReaderStatus(status);
      });
      // EventEmitter.reLounchApp();
    }
    this.props.setScreenSaverStatus(
      this.props.deviceInfo?.deviceTypeId === 7 ||
      this.props.deviceInfo?.deviceTypeId === 6
    );
    this.props.setSocketConnection(false);
    const auth = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('auth')),
      0
    );
    const connectionOptions = {
      reconnectionDelay: 500,
      reconnectionAttempts: Infinity,
    };

    const isDriveThru = getObjectValue(
      () =>
        [3].includes(
          JSON.parse(window.sessionStorage.getItem('deviceInfo'))?.deviceGroup
            ?.startMode
        ),
      false
    );
    if (auth) {
      socketConnector({
        url: auth?.cApiHostname
          ? auth.cApiHostname
          : process.env.REACT_APP_API_SOCKET_HOST ||
          'https://yapi.dev.onedine.com/iapi/connect',
        connectCallback: () => {
          console.warn('websocket connection successful');
        },
        disconnectCallback: () => {
          console.warn('websocket connection unsuccessful');
        },
        connectionOptions,
        apiKey: this.props?.deviceInfo?.apiKey,
        deviceExternalId: this.props.deviceInfo.deviceExternalId,
        storeId: this.props.deviceInfo.storeId,
        deviceTypeId: this.props.deviceInfo.deviceTypeId,
        // logCapiClientHealthInfo: this.logCapiClientHealthInfoHandler,
        subscriber: isDriveThru
          ? () => { }
          : data => {
            this.checkForErrorOrder(data?.checkHeader, data);
            subscribe(data);
          },
      });
    }
    // https://yapi.dev.onedine.com/iapi/connect

    if (this.props.socketConnected) {
      this.getWebSocketsData(auth);
    }
  }

  checkForErrorOrder = check => {
    const { errorOrderFlag } = this.props;
    if (errorOrderFlag) return;
    const deviceGroup = safeJsonParse(
      window.sessionStorage.getItem('deviceInfo'),
      {}
    )?.deviceGroup;
    let showErrorOrder = false;

    if (!isObjectBlank(deviceGroup)) {
      showErrorOrder = deviceGroup?.fireBoardSettings?.displayErrorOrderWarning;
    }

    if (showErrorOrder) {
      const order = check?.orders?.[0];
      if (order?.orderStatusId === 9) {
        this.props.setErrorOrderFlag(true);
      }
    }
  };

  static getDerivedStateFromProps(props, state) {
    if (
      [7].includes(props.deviceInfo?.deviceTypeId) &&
      getObjectValue(() => state.shouldFlip !== props.userInfo?.flipView, false)
    ) {
      if (document.getElementById('userPreference')) {
        const prevUserPreference = document.getElementById('userPreference');
        try {
          document
            .getElementsByTagName('head')[0]
            .removeChild(prevUserPreference);
        } catch (err) {
          console.log(err);
        }
      }
      if (
        getObjectValue(
          () =>
            safeJsonParse(window.sessionStorage.getItem('userInfo')).flipView,
          {}
        ) &&
        !document.getElementById('userPreference')
      ) {
        const style = document.createElement('style');
        const css = '.rowReverse { flex-direction: row-reverse !important; }';
        style.id = 'userPreference';
        style.appendChild(document.createTextNode(css));
        document.getElementsByTagName('head')[0].appendChild(style);
      }
      if (window.ReactNativeWebView) {
        EventEmitter.postFlipSetting(props.userInfo?.flipView);
      }
      return { shouldFlip: props.userInfo?.flipView };
    }
    if (!props.userInfo && window.ReactNativeWebView) {
      EventEmitter.postFlipSetting(false);
      return { shouldFlip: false };
    }
    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.socketConnected !== prevProps.socketConnected) {
      this.getWebSocketsData(this.props.auth);
    }
    window.scrollTo(0, 0);
  }

  getWebSocketsData = auth => {
    if (auth && !auth?.cApiHostname) {
      authenticate({ headers: { 'api-key': auth.syncApiKey }, id: auth.id });
      subscribeToStoreChecks(getObjectValue(() => auth.id, 0));
      if (![3, 10].includes(this.props.deviceInfo?.deviceTypeId)) {
        getStoreChecks(getObjectValue(() => auth.id, 0));
      }
      if (![11, 8].includes(this.props.deviceInfo?.deviceTypeId)) {
        subscribeToStoreNotifications(getObjectValue(() => auth.id, 0));
        getStoreNotifications(getObjectValue(() => auth.id, 0));
      }
    } else if (this.props?.deviceInfo?.storeId) {
      if (flowType() == 'kds') {
        this.props.getAllCheckPreps(this.props.deviceInfo.storeId);
        this.props.getStoreThemeUrl(
          this.props.auth.brandId,
          this.props?.deviceInfo?.storeId,
          'kds'
        );
      } else if (flowType() === 'fireboard') {
        this.props.getStoreThemeUrl(this.props.auth.brandId, this.props?.deviceInfo?.storeId, 'fireboard')
        if (this.props.deviceInfo?.deviceGroup?.startMode === 6) {
          const venuesInfo = JSON.parse(
            window.sessionStorage.getItem('venuesInfo')
          );
          this.props.getAllChecks(venuesInfo?.id, null, true);
        } else {
          this.props.getAllChecks(this.props.deviceInfo.storeId);
        }
      } else {
        this.props.getAllChecks(this.props.deviceInfo.storeId);
      }
    }
    if (
      auth &&
      ![11, 8, 14, 15].includes(this.props.deviceInfo?.deviceTypeId)
    ) {
      const deviceType = flowType();
      this.props.getStoreThemeUrl(
        this.props.auth.brandId,
        this.props.deviceInfo.storeId,
        deviceType === 'paymentTerminal' ? 'serverApp' : deviceType
      );
    }
  };

  render() {
    const isDriveThru = getObjectValue(
      () =>
        [3].includes(
          JSON.parse(window.sessionStorage.getItem('deviceInfo'))?.deviceGroup
            ?.startMode
        ),
      false
    );

    return (
      <Suspense fallback={<Loader />}>
        {this.props.children}
        {/* Skip InActivity for DriveThru */}
        {!isDriveThru && <InActivity {...this.props} />}
      </Suspense>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getStoreThemeUrl,
      setCardReaderStatus,
      setInActivityStatus,
      setSocketConnection,
      updateChecksAfterResponse,
      setIsAssisstance,
      checkVoid,
      clearCart,
      removeSeat,
      removePaymentCheck,
      addChecks,
      setSeat,
      logout,
      setOpen,
      clearAuthResponse,
      setNotification,
      setScreenSaverStatus,
      getAllChecks,
      getAllCheckPreps,
      logCapiClientHealthInfo,
      setErrorOrderFlag,
    },
    dispatch
  );

const mapStateToProps = ({
  orders,
  oauth,
  storeChecks,
  theme,
  venue,
  errorOrder,
}) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  socketConnected: oauth.socketConnected,
  // check: orders.seats,
  stopPopUp: oauth.isOpen,
  isVenueMode: venue.isVenueMode,
  venueStores: venue.venueStores,
  errorOrderFlag: errorOrder.errorOrderFlag,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScrollToTop);
